(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketingCampaignsListController', MarketingCampaignsListController);

    MarketingCampaignsListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'MarketingCampaign', 'MarketingCampaignCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService', 'smsPanel', '$localStorage'];

    function MarketingCampaignsListController($scope, $state, ParseLinks, AlertService, MarketingCampaign, MarketingCampaignCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService, smsPanel, $localStorage) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.editMarketingCampaign = editMarketingCampaign;
        vm.searchKeyPress = searchKeyPress;
        vm.newMarketingCampaign = newMarketingCampaign;
        vm.clearSearch = clearSearch;
        vm.findApproveStatusStyle = findApproveStatusStyle;
        vm.smsPanel = smsPanel;
        vm.deleteMarketingCampaign = deleteMarketingCampaign;
        vm.getTitle = getTitle;

        loadAll_paging();

       function loadAll_paging() {
           var searchQuery = pagingParams.search || '';
           var actionTypes;

           if (smsPanel) {
               actionTypes = ['SMS_PANEL'];
           } else {
               actionTypes = [
                   'AFTER_INVOICE',
                   'AFTER_RESERVE',
                   'BEFORE_RESERVE',
                   'MARKETING_CAMPAIGN'
               ];
           }

           MarketingCampaignCustom
               .getAllCompanyMarketingCampaigns()
               .query({
                   'action-types': actionTypes,
                   query: searchQuery,
                   page: pagingParams.page - 1,
                   size: paginationConstants.itemsPerPage,
                   sort: sort()
               }, onSuccess, onError);


            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                vm.marketingCampaigns = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


       function search() {
           vm.links = null;
           vm.page = 1;
           vm.predicate = 'id';
           vm.reverse = true;
           vm.currentSearch = vm.searchQuery ? vm.searchQuery.trim() : null;

           vm.transition();
       }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editMarketingCampaign(marketingCampaign) {
            if(smsPanel)
                $state.go('supplierPanel-v2.editMarketingCampaign', {id: marketingCampaign.id, smsPanel: 'true'});
            else  $state.go('supplierPanel-v2.editMarketingCampaign', {id: marketingCampaign.id});
        }

        function deleteMarketingCampaign(marketingCampaign) {
            if(smsPanel)
                $state.go('supplierPanel-v2.deleteSmsPanelMarketingCampaign', {id: marketingCampaign.id});
            else  $state.go('supplierPanel-v2.deleteMarketingCampaign', {id: marketingCampaign.id});
        }

        function newMarketingCampaign() {
            var result;

//            result = Principal.hasSpecialFeatureAccess("marketingCampaign");
//            if (!result) {
//                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
//                return;
//            }
            if(smsPanel) 
                $state.go('supplierPanel-v2.newMarketingCampaign', { smsPanel: 'true' });
            else 
                $state.go('supplierPanel-v2.newMarketingCampaign');
        }

       function clearSearch() {
           vm.links = null;
           vm.page = 1;
           vm.predicate = 'id';
           vm.reverse = true;
           vm.searchQuery = null;
           vm.currentSearch = null;

           vm.transition();
       }

        function findApproveStatusStyle(approveStatus) {
            return "marketing-approve-status marketing-approve-status-" + approveStatus;
        }

        function getTitle()
        {
            return 'tikonApp.marketingCampaign.home.title';
        }

    }
})();
